import { Type, type Static } from '@sinclair/typebox';
import { AttachmentSchema } from '../../shared/attachment/attachment.schema';
import { EmailAttendeeSchema } from '../email/email.schema';

export const EmailDraftSchema = Type.Object({
  object: Type.Literal('EmailDraft'),
  id: Type.String({ description: 'The ID of the draft.' }),
  thread_id: Type.Optional(
    Type.String({
      description:
        'The ID of the thread the draft belongs to. For IMAP drafts, this field is present only when the server provides a native thread ID.',
    }),
  ),
  body: Type.String({ description: 'The body of the draft.' }),
  snippet: Type.String({ description: 'The snippet (preview) of the draft.' }),
  subject: Type.String({ description: 'The subject of the draft.' }),
  from: Type.Optional(
    Type.Array(EmailAttendeeSchema, { description: 'The list of attendees that the email should be sent from.' }),
  ),
  to: Type.Optional(Type.Array(EmailAttendeeSchema, { description: 'The list of attendees that the email should be sent to.' })),
  cc: Type.Optional(Type.Array(EmailAttendeeSchema, { description: "The list of attendees that the email should be CC'd to." })),
  bcc: Type.Optional(
    Type.Array(EmailAttendeeSchema, { description: "The list of attendees that the email should be BCC'd to." }),
  ),
  reply_to: Type.Optional(
    Type.Array(EmailAttendeeSchema, { description: 'The list of attendees that the replies should be sent to.' }),
  ),
  attachments: Type.Array(AttachmentSchema, { description: 'The attachments of the draft.' }),
  folders: Type.Array(Type.String(), { description: 'The folder the draft is in. For Gmail, the labels assigned to the draft.' }),
  categories: Type.Optional(
    Type.Array(Type.String({ description: '(Outlook only) Name of a category assigned to the draft.' }), {
      description: 'List of categories assigned to the draft.',
    }),
  ),
});

export type EmailDraft = Static<typeof EmailDraftSchema>;
